import React from "react";

import { UserGroupManagement } from "@components/UserGroup";

export default function UserGroupIndex() {
  return (
    <div>
      <UserGroupManagement />
    </div>
  );
}
